{
  "info": "Informazioni",
  "negative": "Errore",
  "positive": "Operazione riuscita"
}
